export class Colors {
  public static readonly Black = "#000000";
  public static readonly White = "#FFFFFF";
}